<template>
  <el-dialog
    id="RefuseDetail"
    title="拒绝原因"
    width="30%"
    center
    :visible.sync="visible">
    <template v-if="desc">
      <p>{{desc}}</p>
    </template>
    <template v-if="path&&path.length">
      <img v-for="(item,index) in path" :key="index" :src="item" @click="openImage(item)"/>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: "rules-detail",
    data() {
      return {
        visible: false,
        desc: '',
        path:''
      }
    },
    methods: {
      init (desc, path) {
        this.visible = true
        this.desc = desc
        this.path = JSON.parse(path)
      },
      openImage (url) {
        window.open(url + '?t=' + new Date().getTime())
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-dialog__body{
    padding: 0 20px 30px 20px;
  }
  p{
    line-height: 30px;
    text-indent: 2em;
    text-align: left;
  }
  img{
    max-width: 100%;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .el-dialog {
      width: 98%!important;
    }

    /deep/ .el-dialog__body {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/refuse-receive-detail.vue